import React, {useEffect} from 'react'
import './about.less'
import Navbar from '../components/Navbar/Navbar';
import AboutHero from '../components/about/Hero/AboutHero';
import VisionMission from '../components/about/VisionMission/VisionMission';
import Wwd from '../components/about/WhatWeDo/Wwd';
import Founder from '../components/about/Founder/Founder';
import Footer from '../components/Footer/Footer'

export default function About() {
        useEffect(()=>{
        const animOne = document.querySelectorAll('.anim-one');
        const animTwo = document.querySelectorAll('.anim-two');
        const animThree = document.querySelectorAll('.anim-three');
        
        let options = {
            threshold: 0.25
          }
      
        const observer = new IntersectionObserver((entries)=>{
          entries.forEach((entry)=>{
            if(entry.intersectionRatio > 0){
              if(entry.target.classList.contains('anim-one')){
                entry.target.style.animation = `animUp 0.5s ${entry.target.dataset.delay} forwards linear`;
              }else if(entry.target.classList.contains('anim-two')){
                entry.target.style.animation = `animDown 0.5s ${entry.target.dataset.delay} forwards linear`;
              }else if(entry.target.classList.contains('anim-three')){
                entry.target.style.animation = `animDownTwo 0.5s ${entry.target.dataset.delay} forwards linear`;
              }
            }
          })
        }, options)
    
        animOne.forEach(anim => {
          observer.observe(anim);
        })
        animTwo.forEach(anim => {
          observer.observe(anim);
        })
        animThree.forEach(anim => {
          observer.observe(anim);
        })
  },[]);
    return (
        <section className="about">
            <Navbar/>
            <AboutHero/>
            <section className="about-center">
              <VisionMission/>
              <div className="seperator anim-three" data-delay="0.5s"></div>
              <Wwd/>
              <div className="seperator anim-three" data-delay="0.5s"></div>
              <Founder/>
            </section>
            <Footer/>
        </section>
    )
}
